import React from 'react';
import { Field } from 'formik';

interface ICaseNameProps {
  ticketName: string,
  edit: boolean,
}

const CaseName: React.FC<ICaseNameProps> = (props: ICaseNameProps) => {
  const { ticketName, edit } = props;


  return (
    <div className='vault-form-entity'>
      <div className='vault-form-row'>
        <div className='vault-form-combo'>
          <p className='vault-form-label'>Ticket Name</p>
          <Field className='vault-form-input' name='ticketName' value={ticketName} disabled={!edit}></Field>
        </div>
      </div>
    </div>
  );
};

export default CaseName;

